import React from 'react'
import clsx from 'clsx'

import RuangGTKHeader from 'components/ResponsiveLayout/Header'
import PageContainer from 'components/ResponsiveLayout/PageContainer'
import Breadcrumb from 'components/ResponsiveLayout/Breadcrumb'

import type { BreadcrumbItemDef } from 'components/ResponsiveLayout/Breadcrumb'

export type { BreadcrumbItemDef }

type NavLink = {
  label: string
  href: string
  external?: boolean
}

interface DesktopPageHeaderProps {
  breadcrumbItems?: BreadcrumbItemDef[]
  /** Tailwind classes applied to the breadcrumb bar wrapper (background, border, etc.) */
  breadcrumbClassName?: string
  /** Tailwind classes applied to the breadcrumb text, for coloured backgrounds */
  breadcrumbTextClassName?: string
  navLinks?: NavLink[]
  bottomBar?: React.ReactNode
}

const DesktopPageHeader = ({
  breadcrumbItems,
  breadcrumbClassName,
  breadcrumbTextClassName,
  navLinks,
  bottomBar,
}: DesktopPageHeaderProps) => (
  <div className="sticky top-0 z-50 shrink-0 bg-white">
    <RuangGTKHeader showSearch={false} navLinks={navLinks} />
    {breadcrumbItems && breadcrumbItems.length > 0 && (
      <div className={clsx('border-b', breadcrumbClassName ?? 'bg-white')}>
        <PageContainer className="!py-2 !pt-1">
          <Breadcrumb
            items={[{ label: 'Beranda', href: '/' }, ...breadcrumbItems]}
            className={breadcrumbTextClassName}
          />
        </PageContainer>
      </div>
    )}
    {bottomBar}
  </div>
)

export default DesktopPageHeader
